import React from "react";
import { Icon, IconProps } from "@chakra-ui/icons";
import {
  FaChevronDown,
  FaChevronRight,
  FaCircle,
  FaCog,
  FaCreditCard,
  FaEllipsisH,
  FaGift,
  FaList,
  FaMicrosoft,
  FaRegCreditCard,
  FaUserFriends,
  FaUserLock,
} from "react-icons/fa";
import {
  FaAddressCard,
  FaBan,
  FaCalendarDays,
  FaCircleXmark,
  FaRegCalendar,
  FaRegCircleXmark,
} from "react-icons/fa6";
import {
  FiBook,
  FiBookOpen,
  FiCheck,
  FiCheckCircle,
  FiClock,
  FiCopy,
  FiCornerDownRight,
  FiCreditCard,
  FiDownload,
  FiEdit,
  FiFileText,
  FiFilter,
  FiGlobe,
  FiInfo,
  FiLock,
  FiLogOut,
  FiMail,
  FiMapPin,
  FiMoreHorizontal,
  FiMoreVertical,
  FiPlus,
  FiRefreshCw,
  FiRepeat,
  FiRotateCcw,
  FiSearch,
  FiSmartphone,
  FiTrash2,
  FiUser,
  FiUserPlus,
  FiX,
  FiXCircle,
  FiZap,
} from "react-icons/fi";
import { RiShareBoxFill } from "react-icons/ri";
import { TbPin, TbPinFilled, TbReplaceFilled } from "react-icons/tb";
import { IconType } from "react-icons/lib";
import { GoQuestion } from "react-icons/go";
import { IoCalendar, IoCheckmarkCircleOutline } from "react-icons/io5";
import { BsClockFill } from "react-icons/bs";
import {
  MdCardMembership,
  MdCheckCircle,
  MdLocationOn,
  MdOutlineSettings,
  MdVerifiedUser,
} from "react-icons/md";
import { PiShoppingCartSimpleBold, PiWarningFill } from "react-icons/pi";
import { IoIosSend, IoMdNotifications } from "react-icons/io";
import { HiOutlineSparkles } from "react-icons/hi2";
import { SlPencil } from "react-icons/sl";
import { VscWand } from "react-icons/vsc";

/**
 * Wraps a non Chakra icon in a <Icon/> component
 * @param icon
 * @returns
 */
const wrapIcon = (icon: IconType) => {
  return (props: IconProps) => <Icon {...props} as={icon} />;
};

export const CogIcon = wrapIcon(FaCog);

export const CircleIcon = wrapIcon(FaCircle);

export const EventsIcon = wrapIcon(FaCalendarDays);

export const ListIcon = wrapIcon(FaList);

export const UserIcon = wrapIcon(FiUser);

export const UsersIcon = wrapIcon(FaUserFriends);

export const UserPlusIcon = wrapIcon(FiUserPlus);

export const UserLockIcon = wrapIcon(FaUserLock);

export const LockIcon = wrapIcon(FiLock);

export const MoreHorizontal = wrapIcon(FiMoreHorizontal);

export const PlusIcon = wrapIcon(FiPlus);

export const LogoutIcon = wrapIcon(FiLogOut);

export const MailIcon = wrapIcon(FiMail);

export const DeleteIcon = wrapIcon(FiX);

export const EditIcon = wrapIcon(FiEdit);

export const CheckIcon = wrapIcon(FiCheck);

export const TrashIcon = wrapIcon(FiTrash2);

export const RefreshIcon = wrapIcon(FiRefreshCw);

export const CardIcon = wrapIcon(FiCreditCard);

export const PhoneIcon = wrapIcon(FiSmartphone);

export const TransferIcon = wrapIcon(FiRepeat);

export const ZapIcon = wrapIcon(FiZap);

export const CheckCircleIcon = wrapIcon(FiCheckCircle);

export const CheckCircleFillIcon = wrapIcon(MdCheckCircle);

export const XCircleIcon = wrapIcon(FiXCircle);

export const InfoIcon = wrapIcon(FiInfo);

export const FileIcon = wrapIcon(FiFileText);

export const CreditCardIcon = wrapIcon(FaCreditCard);

export const GiftCardIcon = wrapIcon(FaGift);

export const BoxShareIcon = wrapIcon(RiShareBoxFill);

export const SearchIcon = wrapIcon(FiSearch);

export const BookIcon = wrapIcon(FiBook);

export const RenewalIcon = wrapIcon(TbReplaceFilled);

export const CancelIcon = wrapIcon(FaBan);

export const XmarkIcon = wrapIcon(FaCircleXmark);

export const BookOpenIcon = wrapIcon(FiBookOpen);

export const MicrosoftIcon = wrapIcon(FaMicrosoft);

export const QuestionIcon = wrapIcon(GoQuestion);

export const SettingsIcon = wrapIcon(MdOutlineSettings);

export const DownloadIcon = wrapIcon(FiDownload);

export const MoreVerticalIcon = wrapIcon(FiMoreVertical);

export const SidebarMembersIcon = wrapIcon(FaAddressCard);

export const SidebarEventsIcon = wrapIcon(IoCalendar);

export const SidebarCardsIcon = wrapIcon(FaRegCreditCard);

export const SidebarCardOrdersIcon = wrapIcon(PiShoppingCartSimpleBold);

export const SidebarMembershipIcon = wrapIcon(MdCardMembership);

export const SidebarPushNotificationIcon = wrapIcon(IoMdNotifications);

export const TabItemSelectIcon = wrapIcon(FaChevronRight);

export const ChevronDownIcon = wrapIcon(FaChevronDown);
export const ChevronRightIcon = wrapIcon(FaChevronRight);
export const CornerDownRightIcon = wrapIcon(FiCornerDownRight);

export const ContextMenuIcon = wrapIcon(FaEllipsisH);

export const PublishEventIcon = wrapIcon(IoIosSend);

export const FilterIcon = wrapIcon(FiFilter);

export const NotificationScheduleDateIcon = wrapIcon(FaRegCalendar);

export const NotificationScheduleTimeIcon = wrapIcon(FiClock);

export const NotificationScheduleTimezoneIcon = wrapIcon(FiGlobe);

export const StartNotificationScheduleIcon = wrapIcon(BsClockFill);

export const CloneIcon = wrapIcon(FiCopy);

export const RevertIcon = wrapIcon(FiRotateCcw);

export const PinIcon = wrapIcon(TbPin);

export const PinFilledIcon = wrapIcon(TbPinFilled);

export const SparklesIcon = wrapIcon(HiOutlineSparkles);

export const PencilIcon = wrapIcon(SlPencil);

export const CheckmarkCircleOutlineIcon = wrapIcon(IoCheckmarkCircleOutline);

export const WandIcon = wrapIcon(VscWand);

export const VerifiedUserIcon = wrapIcon(MdVerifiedUser);

export const WarningFillIcon = wrapIcon(PiWarningFill);

export const FaRegCircleXmarkIcon = wrapIcon(FaRegCircleXmark);

export const MapPinIcon = wrapIcon(FiMapPin);

export const MapPinFilledIcon = wrapIcon(MdLocationOn);
